<div class="row">
    <div class="col-xl-12">
        <div class="card card-box p-3 mb-5">
            <div class="d-flex align-items-center py-4 px-5 justify-content-between">
                <div class="pr-2">
                    <h6 class="font-weight-bold mb-2">Updated Version (8.1.2) ... April 17, 2023</h6>
                    <p class="opacity-6 font-size-md mb-0">
                        1. Payment Mode not at all required to create a Retail Transactio<br/>
                        2. Adding the Services from the edit Reservation Page <br/> 
                        3. Remove the Pre-Authorize while creating the Retail Reservations <br/> 
                        4. Customers/Agencies show both Active/Inactive List <br/>   
                        5. Thrash the Service(s) and update the Transaction Table(s)/Service Table(s) <br/>             
                    </p>
                    <hr/>
                    <h6 class="font-weight-bold mb-2">Updated Version (8.1) ... March 19, 2023</h6>
                    <p class="opacity-6 font-size-md mb-0">
                        1. Account Receivable module & Chase Integration : Payment Type Pending, To Be Billed, Paid Transanction,Reports , Dasboards<br/>
                        2. Add Customers, Agencies, Taxrates-- Administration <br/> 
                        3. Add Reservation Modifications <br/> 
                        4. Meeting Time Implementation <br/>   
                        5. Major Bug Fixes <br/>                 
                    </p>
                    <hr/>
                    <h6 class="font-weight-bold mb-2">Updated Version (6.1) ... Aug 17, 2022</h6>
                    <p class="opacity-6 font-size-md mb-0">
                        1. Added Secondary Agent Feature <br/>
                        3. Contract Services <br/> 
                        2. Super Admin Add and View <br/> 
                        3. Bug Fixes   <br/>                
                    </p>
                    <hr/>
                    <h6 class="font-weight-bold mb-2">Updated Version (6.0) ... June 13, 2022</h6>
                    <p class="opacity-6 font-size-md mb-0">
                        1. Manual e-Mail Templates for Amex/Retail(Confirmation/Waitlist/Confirmed) <br/>
                        2. Bell Icon Intimation of Greet Requests from any page.    <br/>                
                        3. Waitlist Reservations have been underlined in Assigned Greets Tab.  <br/> 
                        4. Assigned by has to be recorded and displayed on Greet Timeline History.<br/>
                    </p>
                    <hr/>
                    <h6 class="font-weight-bold mb-2">Updated Version (5.9) ... June 2, 2022</h6>
                    <p class="opacity-6 font-size-md mb-0">
                        1.Added additional filters to Agent Payroll Report Page <br/>
                        2.Added filter 'Reservation Type' in Reservation page <br/>
                        3.Agent Payroll Report(Excel Data) Modified  <br/>
                        4.Added Cancellation Data Excel Report  <br/>
                        5.Minor issues fixed  <br/>
                    </p>
                </div>
            </div>
        </div>
    </div>
</div>
